<template>
  <div class="compiler">

    <input type="text" v-model="password" v-if="!isUnlocked">

    <div class="wrapper" v-if="isUnlocked">
      <h1>Card Data Compliler</h1>
      <div class="flex">
        <div>
          <h2>Cards Data</h2>
          <textarea class="textinput" type="text" v-model="cardInput"></textarea>
        </div>
        <div>
          <h2>Relics Data</h2>
          <textarea class="textinput" type="text" v-model="relicsInput"></textarea>
        </div>
      </div>
      <div class="button" @click.prevent="compile">Compile</div>
      <ul class="errors">
        <li v-for="(error, index) in errors">
          {{error}}
        </li>
      </ul>
      <div class="tests">
        <div v-for="(result, index) in testResults" :key="index">
          <p class="fail-main" :class="{ 'pass-main': result.pass === true, 'notrun-main': result.type === 'Test not run' }">{{result.name}}</p>
          <p class="fail" :class="{ pass: result.pass === true,  notrun: result.type === 'Test not run' }">{{result.type}}</p>
        </div>
        <ul class="errors">
          <li v-for="(message, index) in testFailMessages">
            {{message}}
          </li>
        </ul>
      </div>
      <h1>Comparisions</h1>
      <h2>{{comparisions}}</h2>
      <h1>Result</h1>
        <div class="flex">
        <div>
          <h2>Cards Data</h2>
          <textarea class="textinput" type="text" v-model="cardsOutput"></textarea>
        </div>
        <div>
          <h2>Relics Data</h2>
          <textarea class="textinput" type="text" v-model="relicsOutput"></textarea>
        </div>
      </div>
      <h2>Complete Data</h2>
      <textarea class="textinput" type="text" v-model="dataOutput"></textarea>
      <h2 v-if="!prerenderIdentical">Prerender Routes</h2>
      <div v-if="!prerenderIdentical">NEW RENDER ROUTES</div>
      <textarea v-if="!prerenderIdentical" class="textinput" type="text" v-model="prerenderOutput"></textarea>
    </div>
  </div>
</template>

<script>

import testsJSON from './datatests.json';
import prerenderRoutesItems from './prerenderRoutesItems.json';

export default {
  name: 'sls-carddatacompiler',
  data() {
    return {
      // cardInput: '',
      /* tslint:disable-next-line:max-line-length */
      cardInput: '[{ "FIELD1": "ironclad", "FIELD2": "Blood for Blood", "FIELD3": "attack", "FIELD4": "", "FIELD5": 4, "FIELD6": 4, "FIELD7": "tag:sacrifice,tag:heal", "FIELD8": "tag:block", "FIELD9": "uncommon", "FIELD10": "Costs 1 less [energy] for each time you lose HP in combat. Deal ^18 damage.", "FIELD11": "Costs 1 less [energy] for each time you lose HP in combat. Deal ^22 damage." },{ "FIELD1": "ironclad", "FIELD2": "Entrench", "FIELD3": "skill", "FIELD4": "block", "FIELD5": 2, "FIELD6": 1, "FIELD7": "card:Barricade,card:Impervious", "FIELD8": "", "FIELD9": "uncommon", "FIELD10": "Double your current Block.", "FIELD11": "Double your current Block." },{ "FIELD1": "ironclad", "FIELD2": "Corruption", "FIELD3": "power", "FIELD4": "exhaust", "FIELD5": 3, "FIELD6": 2, "FIELD7": "ratio:type:skill:0.3:>,relic:Dead Branch,type:skill&mana:>1", "FIELD8": "", "FIELD9": "uncommon", "FIELD10": "Skills cost 0. Whenever you play a Skill, Exhaust it.", "FIELD11": "Skills cost 0. Whenever you play a Skill, Exhaust it." },{ "FIELD1": "ironclad", "FIELD2": "Bloodletting", "FIELD3": "skill", "FIELD4": "managain,sacrifice", "FIELD5": 0, "FIELD6": 0, "FIELD7": "", "FIELD8": "mana:>1", "FIELD9": "uncommon", "FIELD10": "Gain [energy]. Lose 3 HP.", "FIELD11": "Gain [energy] [energy]. Lose 3 HP." },{ "FIELD1": "silent", "FIELD2": "Bane", "FIELD3": "attack", "FIELD4": "poison,multihit", "FIELD5": 1, "FIELD6": 1, "FIELD7": "", "FIELD8": "", "FIELD9": "common", "FIELD10": "Deal ^7 damage. If the enemy is Poisoned, deal ^7 damage again.", "FIELD11": "Deal ^10 damage. If the enemy is Poisoned, deal ^10 damage again." },{ "FIELD1": "silent", "FIELD2": "Reflex", "FIELD3": "skill", "FIELD4": "unplayable,draw", "FIELD5": -2, "FIELD6": -2, "FIELD7": "card:Concentrate", "FIELD8": "", "FIELD9": "uncommon", "FIELD10": "Unplayable. If this card is discarded from your hand, draw ^1 card.", "FIELD11": "Unplayable. If this card is discarded from your hand, draw ^2 cards." },{ "FIELD1": "silent", "FIELD2": "Noxious Fumes", "FIELD3": "power", "FIELD4": "poison,aoe", "FIELD5": 1, "FIELD6": 1, "FIELD7": "", "FIELD8": "", "FIELD9": "uncommon", "FIELD10": "At the start of your turn, apply 2 Poison to ALL enemies.", "FIELD11": "At the start of your turn, apply ^3 Poison to ALL enemies." }, { "FIELD1": "silent", "FIELD2": "Die Die Die", "FIELD3": "attack", "FIELD4": "exhaust,aoe", "FIELD5": 1, "FIELD6": 1, "FIELD7": "", "FIELD8": "", "FIELD9": "rare", "FIELD10": "Deal ^13 damage to ALL enemies. Exhaust.", "FIELD11": "Deal ^17 damage to ALL enemies. Exhaust." }, { "FIELD1": "silent", "FIELD2": "Choke", "FIELD3": "attack", "FIELD4": "", "FIELD5": 2, "FIELD6": 2, "FIELD7": "card:Distraction,mana:=0,tag:shiv", "FIELD8": "mana:>1", "FIELD9": "uncommon", "FIELD10": "Deal 12 damage. Whenever you play a card this turn, targeted enemy loses ^3 HP.", "FIELD11": "Deal 12 damage. Whenever you play a card this turn, targeted enemy loses ^5 HP." }, { "FIELD1": "ironclad", "FIELD2": "Whirlwind", "FIELD3": "attack", "FIELD4": "aoe,multihit", "FIELD5": -1, "FIELD6": -1, "FIELD7": "", "FIELD8": "", "FIELD9": "uncommon", "FIELD10": "Deal ^5 damage to ALL enemies X times.", "FIELD11": "Deal ^8 damage to ALL enemies X times." },{ "FIELD1": "silent", "FIELD2": "Reflex", "FIELD3": "skill", "FIELD4": "unplayable,draw", "FIELD5": -2, "FIELD6": -2, "FIELD7": "card:Concentrate", "FIELD8": "", "FIELD9": "uncommon", "FIELD10": "Unplayable. If this card is discarded from your hand, draw ^1 card.", "FIELD11": "Unplayable. If this card is discarded from your hand, draw ^2 cards." },{ "FIELD1": "silent", "FIELD2": "Tools of the Trade", "FIELD3": "power", "FIELD4": "draw,discard", "FIELD5": 1, "FIELD6": 0, "FIELD7": "tag:unplayable", "FIELD8": "", "FIELD9": "rare", "FIELD10": "At the start of your turn, draw 1 card and discard 1 card.", "FIELD11": "At the start of your turn, draw 1 card and discard 1 card." }]',
      cardDataString: '',
      cards: [],
      cardsFinal: [],
      cardsOutput: '',

      // relicsInput: '',
      /* tslint:disable-next-line:max-line-length */
      relicsInput: '[{ "FIELD1": "any", "FIELD2": "Snecko Eye", "FIELD3": "boss", "FIELD4": "Draw 2 additional cards each turn. Start each combat Confused.", "FIELD5": "draw", "FIELD6": "mana:>1", "FIELD7": "mana:<2" },{ "FIELD1": "any", "FIELD2": "Vajra", "FIELD3": "common", "FIELD4": "At the start of each combat, gain 1 Strength.", "FIELD5": "strength", "FIELD6": "", "FIELD7": "" },{ "FIELD1": "any", "FIELD2": "Gambling Chip", "FIELD3": "rare", "FIELD4": "At the start of each combat, discard any number of cards then draw that many.", "FIELD5": "discard", "FIELD6": "type:power", "FIELD7": "" },{ "FIELD1": "any", "FIELD2": "Bag of Marbles", "FIELD3": "common", "FIELD4": "At the start of each combat, apply 1 Vulnerable to ALL enemies.", "FIELD5": "vulnerable", "FIELD6": "tag:innate&type:attack", "FIELD7": "" }]',
      relicsDataString: '',
      relics: [],
      relicsFinal: [],
      relicsOutput: '',

      tests: testsJSON,
      testResults: [
        // {
        //   name: 'Choke [Card] - Bane [Card]',
        //   type: 'Synergy',
        //   pass: true,
        // }
      ],
      testFailMessages: [],

      // Final Data
      data: {},
      dataOutput: '',
      prerenderOutput: [],
      prerenderCurrentRoutes: prerenderRoutesItems,
      prerenderIdentical: true,

      // Fun stuff
      comparisions: 0,

      errors: [],
      buttonText: 'Compile',
      password: '', // @git-ignore
      a37891hd821nd9q8eej9: 'slsjd',
    };
  },
  /* tslint:disable:no-console*/

  methods: {
    // Gatekeeper
    compile() {
      this.buttonText = 'Loading';
      // this.relicsCompiler()

      if (this.cardInput.length > 0) {
        this.cardsCompiler();
      }

      // remove unwanted tags

      this.buttonText = 'Compile';
    },
    // Card compiler
    cardsCompiler() {
      // console.log('Start Cards');
      this.errors = [];
      // set string statement
      this.cardDataString = this.cardInput;
      this.stringFieldNames();
      // this.tagsArray()

      // this.cards = [];
      this.cards = JSON.parse(this.cardDataString);

      // add empty key arrays
      this.objAddKey(this.cards, 'synergies');
      this.objAddKey(this.cards, 'antisynergies');
      this.objAddKey(this.cards, 'statementssynergies');
      this.objAddKey(this.cards, 'statementsantisynergies');
      this.objAddKey(this.cards, 'ratios');
      this.objAddKey(this.cards, 'object', 'card');

      // fix beta values
      this.betaValues();

      // convert string to array
      this.objKeyStringToArray(this.cards, 'tags');
      this.objKeyStringToArray(this.cards, 'synergiespre');
      this.objKeyStringToArray(this.cards, 'antisynergiespre');

      // convert string to number
      this.stringToNumber('mana');
      this.stringToNumber('manaplus');

      // statements
      this.statements(this.cards, 'synergies');
      this.statements(this.cards, 'antisynergies');

      // ratios
      this.ratios(this.cards, 'synergies');
      this.ratios(this.cards, 'antisynergies');


      // add global synergies
      this.objGlobalsynergies(this.cards, true);
      this.objGlobalsynergies(this.cards, false);

      this.relicsCompiler();

      // All relics and cards
      // Add Card Index Number
      this.objAddKeyIndex();

      // run card comparisons
      this.compareAll('synergies');
      this.compareAll('antisynergies');


      // corrections
      this.correctTags('');

      // remove unwanted keytags
      this.removeUnwantedCardKeys('synergiespre');
      this.removeUnwantedCardKeys('antisynergiespre');


      // this.removeUnwantedCardKeys('index');

      this.dataFinalise('card');
      this.dataFinalise('relic');

      this.data.cards = this.cardsFinal;
      this.data.relics = this.relicsFinal;

      this.removeObjectKeys('cards');
      this.removeObjectKeys('relics');

      // Test synergies
      this.dataTests();

      this.jsonOutput('cards');
      this.jsonOutput('relics');
      this.jsonOutputFinal();

      this.prerenderdata();
    },
    stringFieldNames() {
      this.cardDataString = this.cardDataString.replace(/FIELD14/g, 'priority');
      this.cardDataString = this.cardDataString.replace(/FIELD13/g, 'tier');
      this.cardDataString = this.cardDataString.replace(/FIELD12/g, 'beta');
      this.cardDataString = this.cardDataString.replace(/FIELD11/g, 'descriptionplus');
      this.cardDataString = this.cardDataString.replace(/FIELD10/g, 'description');
      this.cardDataString = this.cardDataString.replace(/FIELD9/g, 'rarity');
      this.cardDataString = this.cardDataString.replace(/FIELD8/g, 'antisynergiespre');
      this.cardDataString = this.cardDataString.replace(/FIELD7/g, 'synergiespre');
      this.cardDataString = this.cardDataString.replace(/FIELD6/g, 'manaplus');
      this.cardDataString = this.cardDataString.replace(/FIELD5/g, 'mana');
      this.cardDataString = this.cardDataString.replace(/FIELD4/g, 'tags');
      this.cardDataString = this.cardDataString.replace(/FIELD3/g, 'type');
      this.cardDataString = this.cardDataString.replace(/FIELD2/g, 'name');
      this.cardDataString = this.cardDataString.replace(/FIELD1/g, 'character');
    },
    betaValues() {
      this.cards.forEach((card) => {
        if (card.beta) {
          card.beta = true;
        } else {
          card.beta = false;
        }
      });
    },
    objAddKey(type, key, value = null) {
      type.forEach((single) => {
        if (value === null) {
          single[key] = [];
        } else {
          single[key] = value;
        }
      });
    },

    // is this redundant?
    objAddKeyIndex() {
      this.cards.forEach((card, index) => {
        card.index = index;
      });
    },
    objKeyStringToArray(type, key) {
      // console.group(`Converting ${key} string to array of strings`);
      type.forEach((single) => {
        const values1D = single[key].split(',');
        const values2D = [];
        single[key] = [];

        values1D.forEach((mixedValue) => {
          // console.log(key);

          if (mixedValue !== '') {
            const formatedValues = mixedValue.split('&');
            single[key].push(formatedValues);
          }
        });
      });
      // console.log('Complete');
      // console.groupEnd();
    },
    stringToNumber(key) {
      const vue = this;
      this.cards.forEach((card, cardindex) => { // for each card
        if ( isNaN( parseInt(card[key], 10 ) ) ) {
          vue.errorMessage( card.name + ' ' + key + ' cannot convert to a number');
        }
        card[key] = parseInt(card[key], 10);
      });
    },
    objGlobalsynergies(type, isSynergies) {
      // add relevent tag to each card
      // sacrifice and heal
      const targetArray = isSynergies ? 'synergiespre' : 'antisynergiespre';
      const synergies = isSynergies ? [
        ['tag:heal', 'tag:sacrifice'],
        ['tag:gold', 'tag:gold'],
        ['tag:poison', 'tag:poison'],
        ['tag:strength', 'tag:aoe&type:attack'],
        ['tag:strength', 'tag:multihit'],
        ['tag:unplayable', 'tag:discard'],
        ['tag:shiv', 'tag:shiv'],
        ['tag:vulnerable', 'tag:vulnerable'],
        ['tag:slotgain', 'tag:focus'],
        ['tag:focus', 'tag:channel'],
        ['tag:focus', 'tag:evoke'],
        ['tag:slotgain', 'tag:channel'],
        ['tag:focus', 'tag:focus'],
        ['tag:mantra', 'tag:mantra'],
        ['tag:wrath', 'tag:exit'],
        ['tag:calm', 'tag:exit'],
        ['tag:scry', 'type:curse'],
      ] :
        [
          ['tag:ethereal', 'tag:ethereal'],
          ['tag:evoke', 'tag:slotgain'],
          ['tag:evoke', 'tag:evoke'],
        ]; // anti synergies

      // get search type
      type.forEach((single, cardindex) => { // for each single (card/relic)
      // console.group('Checking ' + single.name + ' for global synergies');

        synergies.forEach((synergyPair) => { // for each inate synergy
          // for tags
          const array = synergyPair[0].split(':');
          let key = array[0];
          const value = array[1];
          if (key === 'tag') {
            key = 'tags';
          }
          for (let a = 0; a < single[key].length; a++) { // check single.key (eg tags) for match
            // console.log(single[key][a][0]);

            if (single[key][a][0] === value) { // if matches
              // console.group(single.name + ' matched for ' + key + ' ' + value);
              let shouldAdd = true;

              for (let b = 0; b < single[targetArray].length; b++) { // check if already on synergypre etc
                // console.log('Checking match '+ key + ':'+ value  +' against ' + single[targetArray][b][0]);

                if (single[targetArray][b][0] === synergyPair[1]) {
                  // console.log(`Matched: ` + key + ':'+ value + ' not added')
                  shouldAdd = false;
                  break;
                }

              }
              // if true - add to tag
              if (shouldAdd) {
                // let tagToAdd = [synergyPair[1]]
                let tagToAdd = [synergyPair[1].toString()];
                // console.log(tagToAdd);

                if (tagToAdd[0].indexOf('&') !== -1) {
                  // console.log('-- SPLIT THIS --');
                  // console.log(tagToAdd);

                  const splitArray = tagToAdd[0].split('&');
                  // console.log(splitArray);

                  tagToAdd = splitArray;
                  // console.log('-- new tag --');
                  // console.log(tagToAdd);
                }
                single[targetArray].push(tagToAdd);
                // console.groupEnd();
              }
            }
          }
        });
        // console.log(single.name);

        // console.log(single.synergiespre);

      // console.groupEnd()
      });

    },
    compareAll(key) {
      // loop through all cards
      // thiscard, x
      const keyPre = `${key}pre`;
      const vue = this;
      this.cards.forEach((thiscard, thisindex) => {
        // thatcard, y
        vue.cards.forEach((thatcard, thatindex) => {
          // test all synergies on x with card y info

          // dont compare relics with relics
          // if ( !(thiscard.object === 'relic' && thatcard.object === 'relic') && thiscard[keyPre].length > 0){

            console.group(`Comparing '${thiscard.name}' and '${thatcard.name}'`);
            console.log(`${thiscard.name} has ${thiscard[keyPre].length} ${key} rules`);
            for (let thisSynergies = 0; thisSynergies < thiscard[keyPre].length; thisSynergies++) {
              const thisSingleSynergy = thiscard[keyPre][thisSynergies];

              const isMatch = vue.checkIsMatch(thisSingleSynergy, thatcard, key, thiscard);

              if (isMatch) {
                vue.addCardID( thiscard, key, thatindex );
                vue.addCardID( thatcard, key, thisindex );
                console.log(`Added to ${key}: [${thisindex}] [${thatindex}]`);
                // check if duplicate
                console.groupEnd();
                break;
              }
              // if ismatch break
              // console.log(isMatch);
            }
            console.groupEnd();

          // }

        });
      });


      // - loop through all synergies of card x (can be many)
      // -- compare against values of card y (can be many)
    },
    // compareAllThings(thisthing, thatthing, key) {
    //   // loop through all cards
    //   // thiscard, x
    //   const keyPre = `${key}pre`
    //   const vue = this;
    //   this.cards.forEach(function(thiscard, thisindex) {
    //     // console.group(`${thisindex} - ${thiscard.name}`);
    //     // thatcard, y
    //     vue.cards.forEach(function(thatcard, thatindex) {
    //       // console.group(`${thiscard.name} vs ${thatcard.name}`);
    //       // test all synergies on x with y

    //       for (let thisSynergies = 0; thisSynergies < thiscard[keyPre].length; thisSynergies++) {
    //         const thisSingleSynergy = thiscard[keyPre][thisSynergies];

    //         const isMatch = vue.checkIsMatch(thisSingleSynergy, thatcard, key, thiscard);
    //         // console.log(`${isMatch}`);
    //         if (isMatch) {

    //           vue.addCardID(thiscard, key, thatindex )
    //           vue.addCardID(thatcard, key, thisindex )

    //           // thiscard.synergies.push(thatindex)
    //           // check if duplicate

    //           break;
    //         }
    //         // if ismatch break
    //       }
    //       // console.groupEnd();
    //     });
    //     // console.groupEnd();
    //   });
    // },
    // does the synergy pass - bool return
    checkIsMatch(synergies, thatcard, arrayKey, thiscard) {
      // SYNERGIES IS A SINGLE SYNERGY STATEMENT - DOH
      let s = '';
      if (synergies.length > 1) {
        s = 's';
      }
      console.log(`${thiscard.name} synergy rule: [${synergies}], ${synergies.length} statement${s}`);
      // console.log(synergy);

      // Looping through 'and' synergies
      for (var index = 0; index < synergies.length; index++) {
        const synergy = synergies[index].toString();
        // console.log('Checking ' + synergy);
        // console.log(synergy);

        const array = synergy.split(':');
        let key = array[0].toString();

        if (key === 'card') {
          key = 'name';
        }

        if (key === 'relic') {
          // TO DO: relics
          key = 'name';

          // this.errorMessage('relics not implemented')
          // console.log('relics not implemented');
          // return false
        }

        const value = array[1];
        let cardValue = thatcard[key];


        if (key === 'tag') {
          // tags function

          // Console Logs
          let logTags = '';
          for (let t = 0; t < thatcard.tags.length; t++) {
            logTags  += `'${thatcard.tags[t]}'`;
          }
          if (thatcard.tags.length === 0) {
            logTags = 'No tags';
          }
          console.log(`Does '${thatcard.name}' have a ${key} '${value}'? [${logTags}]`);
          // log end

          // Does it have any tags?
          if (thatcard.tags.length === 0) { // No
            return false;
            this.comparisions += 1;

          } else { // Yes

            let addCard = false;
            for (let v = 0; v < thatcard.tags.length; v++) {
              // Is ' + value + ' = ' + thatcard.tags[v][0];
              if (value == thatcard.tags[v][0]) {
                console.log(true);
                this.comparisions += 1;

                addCard = true;
                break
              }
            }

            if (addCard === false) {
              console.log(false);
              return false;
            }

          }


        } else if (key === 'mana') {
          this.comparisions += 1;

          // mana function

          if ((thatcard.mana === undefined && thatcard.manaplus === undefined) && thatcard.object ==='relic') {
            console.log('Item is relic, skipping check');
            return false;
          }
          if (thatcard.mana === undefined){
            const error = `${thatcard.name} is missing mana data`;
            this.errorMessage(error);
            return false;
          }
          if (thatcard.manaplus === undefined){
            const error = `${thatcard.name} is missing mana data`;
            this.errorMessage(error);
            return false;
          }

          if ((thiscard.mana === undefined || thiscard.manaplus === undefined) && thiscard.object !== 'relic') {
            const error = `${thiscard.name} is missing mana data`;
            this.errorMessage(error);
            return false;
          }

          const mathsSymbol = value.charAt(0);
          const manaValue = parseInt(value.substring(1));

          if (!(!(mathsSymbol !== '>') || !(mathsSymbol !== '=') || !(mathsSymbol !== '<'))) {
            const error = `${thiscard.name} mana synergy has a symbol error 'mana:${mathsSymbol}${manaValue}' currently '${mathsSymbol}', fix with < > =`;
            this.errorMessage(error);
            return false;
          }

          if (isNaN(manaValue)){
            const error = `${thiscard.name} mana synergy has a mana cost error 'mana:${mathsSymbol}${value.substring(1)}' currently '${value.substring(1)}'. Please correct to number`;
            this.errorMessage(error);
            return false;
          }

          console.log(`Does ${thatcard.name} have ${key} ${mathsSymbol} ${manaValue}? [${thatcard.mana}]`);

          // 'unplayable' tag (-2) used not mana tag for synergies
          if (thatcard.mana === -2 || thatcard.manaplus === -2) {
            return false;
          }

          // X (-1) counts as every mana cost so true
          if (thatcard.mana !== -1) {

            // else continue
            if (mathsSymbol === '=') {

            if (manaValue !== thatcard.mana || manaValue !== thatcard.manaplus) {
              console.log('false');
              return false;
            }

            } else if (mathsSymbol === '>') {
              // mana greater than
              console.log(manaValue);
              console.log(thatcard.mana);
              console.log(thatcard.mana <= manaValue);


              if (thatcard.mana <= manaValue || thatcard.manaplus <= manaValue) {
                console.log('false');
                return false;
              }

            } else if (mathsSymbol === '<') {
              // mana less that
              if (thatcard.mana >= manaValue || thatcard.manaplus >= manaValue) {
                console.log('false');
                return false;
              }
            }
          }

          // mana end

        } //else if (key === 'statement') {

          // key += 's' + arrayKey;
          // let shouldAdd = true
          // for (let s = 0; s < thiscard[key].length; s++) {
          //   if (thiscard[key][s] === value){
          //     shouldAdd = false
          //     break;
          //   }
          // }
          // if (shouldAdd) {
          //   thiscard[key].push(value);
          //   // console.group(`Adding statement to ${thiscard.name}`);
          //   //   console.log(value);
          //   // console.groupEnd()
          // }
          // return false;

        //}
        // else if (key === 'ratio') {
        //   //console.log('Ratio is frontend');
        //   key += 's';
        //   let ratioString = ''
        //   // console.log(array);

        //   if (array.length < 3) {
        //     this.errorMessage('Ratio '+ arrayKey +' missing parameters')
        //   }
        //   for (let r = 1; r < array.length; r++) {
        //     ratioString += array[r] + ':';
        //   }

        //   ratioString = ratioString.substr(0, (ratioString.length -1));
        //   // console.log(ratioString);

        //   let shouldAdd = true
        //   for (let s = 0; s < thiscard[key].length; s++) {
        //     if (thiscard[key][s] === ratioString){
        //       shouldAdd = false
        //       break;
        //     }
        //   }
        //   if (shouldAdd) {
        //     thiscard.ratios.push(ratioString);
        //     // console.group(`Adding ratio to ${thiscard.name}`);
        //     //   console.log(ratioString);
        //     // console.groupEnd()
        //   }
        //   return false;

        // }
        else if (key === 'type' || key === 'card' || key === 'relic' || key === 'rarity' || key === 'name') {
          console.log(`Is '${thatcard.name}'s ${key} '${value}'? [${thatcard[key]}]`);
          this.comparisions += 1;

          if (thatcard[key] !== value ){
            console.log(false);
            return false;
          }

        } else {
          const error = `${thiscard.name} and ${thatcard.name} has a formatting error for ${synergies} on ${synergy}`;
          this.errorMessage(error)
          return false;
        }
        // log only
        console.log(true);
      };
      return true;
    },
    statements(item, key){
      const keypre = `${key}pre`;
      // add statements to object and remove 'statement:value' from object
      // traverse all objects [card/relic]
      item.forEach(function(object, index) {

        // traverse all key (synergiespre/antisynergiespre) array values
        for (var i = 0; i < object[keypre].length; i++) {
          // value = single synergy / antisynergy
          const rule = object[keypre][i][0];
          //console.log(rule);
          const array = rule.split(':');
          const type = array[0];
          const value = array[1];
          if (type === 'statement') {
            object[`statements${key}`].push(value);
            object[keypre].splice(i, 1);
          }
        }
      })
    },
    ratios(item, key) {
      const keypre = `${key}pre`;
      const vue = this;
      // add statements to object and remove 'statement:value' from object
      // traverse all objects [card/relic]
      item.forEach((object, index) => {
        // traverse all key (synergiespre/antisynergiespre) array values
        // object[keypre].forEach((single, index2) => { - wont work for this as we need to -1 the index when we remove a statement

        for (var i = 0; i < object[keypre].length; i++) {
          // value = single synergy / antisynergy
          console.log(object[keypre][i]);

          const single = object[keypre][i];
          const rule = single[0];

          const array = rule.split(':');
          const type = array[0];

          if (type === 'ratio') {
            // if is ratio
            const fraction = array[3];
            const greaterOrLess = array[4];
            console.log('Ratio Complied');
            console.log(array);
            console.log(type);
            console.log(array[1]);

            console.log(fraction);
            console.log(greaterOrLess);

            // check ratio statement correct
            // 1. Check 4 parts to ratio
            if (array.length < 4) {
              console.error(`${object.name} "ratio" ${rule} missing parameters`);
            }

            // 2. Check ratio has fraction
            if (!fraction.includes(".")) {
              this.errorMessage(`${object.name} "ratio" fraction error [${fraction}]`);
              console.error(`${object.name} "ratio" fraction error [${fraction}]`);
            }

            const fractionNumbers = fraction.split('.')
            console.log(fractionNumbers);
            for (let f = 0; f < fractionNumbers.length; f++) {
              if (isNaN(parseInt(fractionNumbers[f]))) {
                this.errorMessage(`${object.name} ratio fraction error [${fractionNumbers[f]}] is not a number`);
                console.error(`${object.name} ratio fraction error [${fractionNumbers[f]}] is not a number`);
              }
            }

            // 3. Check greater than less than is 1 character
            if (array[4].length !== 1) {
              this.errorMessage(`${object.name} ratio has an error in '>' '<' field, too many characters [${array[4]}]`);
              console.error(`${object.name} ratio has an error in '>' '<' field, too many characters [${array[4]}]`);
            }

            // 4. Check greater than less than is correct character
            if ( array[4] !== '>' && array[4] !== '<' ) {
              this.errorMessage(object.name + ' "ratio" '+ rule + ' has a error in the last part of the statement');
            }
            // Checks End

            let ratioRule = '';
            for (let r = 1; r < array.length; r++) {
              ratioRule += array[r] + ':';
              //console.log(array[r]);
            }
            ratioRule = ratioRule.substr(0, (ratioRule.length -1));
            console.log(ratioRule);

            object.ratios.push(ratioRule);
            object[keypre].splice(i, 1);
            i--;
          }
        }
      })
    },
    addCardID(thiscard, thiskey, thatsynergyID) {
      for (let j = 0; j < thiscard[thiskey].length; j++) {
        if (thiscard[thiskey][j] === thatsynergyID) {
          return
        }
      }
      thiscard[thiskey].push(thatsynergyID);
    },
    errorMessage(message) {
      this.errors.push(message);
    },
    correctTags() {

    },
    removeUnwantedCardKeys(key) {
      this.cards.forEach(function(card){
        delete card[key];
      });
    },
    removeObjectKeys(type) {
      this.data[type].forEach(function(thing){
        delete thing.object;
      });
    },
    dataFinalise(type) {
      console.log(`Finalising ${type}s`);
      this[`${type}sFinal`] = this.cards.filter(card => card.object === type);
      console.log(this[`${type}sFinal`]);
    },
    compileComplete(final, formatted) {
      this.cardsFinal = this.cards;
    },
    jsonOutput(output) {
      this[`${output}Output`] = JSON.stringify(this.data[output], undefined, 4);
    },
    jsonOutputFinal() {
      this[`dataOutput`] = JSON.stringify(this.data, undefined, 4);
    },



    // Relics
    relicsCompiler() {
      //console.log('Start Relics');
      this.errors = [];
      // set string statement
      this.relicsDataString = this.relicsInput;
      this.relicKeyNameCorrection();

      // Create object array
      this.relics = JSON.parse(this.relicsDataString);

      // add empty key arrays
      this.objAddKey(this.relics, 'synergies');
      this.objAddKey(this.relics, 'antisynergies');
      this.objAddKey(this.relics, 'statementssynergies');
      this.objAddKey(this.relics, 'statementsantisynergies');
      this.objAddKey(this.relics, 'ratios');
      this.objAddKey(this.relics, 'object', 'relic');

      // convert string to array
      this.objKeyStringToArray(this.relics, 'tags');
      this.objKeyStringToArray(this.relics, 'synergiespre');
      this.objKeyStringToArray(this.relics, 'antisynergiespre');

      this.statements(this.relics, 'synergies');
      this.statements(this.relics, 'antisynergies');

      this.ratios(this.relics, 'synergies');
      this.ratios(this.relics, 'antisynergies');

      // add global synergies
      this.objGlobalsynergies(this.relics, true);
      this.objGlobalsynergies(this.relics, false);

      const vue = this;
      this.relics.forEach(relic => {
        vue.cards.push(relic);
      });
      // output result
      // this.jsonOutput('relics');
    },
    relicKeyNameCorrection() {
      this.relicsDataString = this.relicsDataString.replace(/FIELD11/g, 'tierwatcher');
      this.relicsDataString = this.relicsDataString.replace(/FIELD10/g, 'tierdefect');
      this.relicsDataString = this.relicsDataString.replace(/FIELD9/g, 'tiersilent');
      this.relicsDataString = this.relicsDataString.replace(/FIELD8/g, 'tierironclad');
      this.relicsDataString = this.relicsDataString.replace(/FIELD7/g, 'antisynergiespre');
      this.relicsDataString = this.relicsDataString.replace(/FIELD6/g, 'synergiespre');
      this.relicsDataString = this.relicsDataString.replace(/FIELD5/g, 'tags');
      this.relicsDataString = this.relicsDataString.replace(/FIELD4/g, 'description');
      this.relicsDataString = this.relicsDataString.replace(/FIELD3/g, 'rarity');
      this.relicsDataString = this.relicsDataString.replace(/FIELD2/g, 'name');
      this.relicsDataString = this.relicsDataString.replace(/FIELD1/g, 'character');
    },
    dataTests() {
      console.log(this.tests);
      const vue = this;
      vue.testResults = [];
      vue.testFailMessages = [];

      this.tests.forEach((test, index) => {
        // find this index
        let thisIndex = 'Not in data set';
        let thatIndex = 'Not in data set';
        const testDataObject = {
          name: '',
          type: `${test[2]}`,
          pass: false,
        };

        console.group(`-- Test ${index + 1} --`);
        for (let card = 0; card < this.data.cards.length; card++) {
          if (this.data.cards[card].name === test[0]) {
            testDataObject.name = `${test[0]} [Card] - `;
            thisIndex = this.data.cards[card].index;
            break;
          }
        }
        if (isNaN(thisIndex)) {
          for (let relic = 0; relic < this.data.relics.length; relic++) {
            if (this.data.relics[relic].name === test[0]) {
              testDataObject.name = `${test[0]} [Relic] - `
              thisIndex = this.data.relics[relic].index;
              break;
            }
          }
        }
        if (isNaN(thisIndex)) {
          vue.testFailMessages.push(`Tests: ${test[0]} not present in data set`);
          testDataObject.name += `${test[0]} [Data not present] - `;
          testDataObject.type = 'Test not run';
        }
        console.log(`Name: ${test[0]}, Index: ${thisIndex}`);

        // find that index
        for (let card = 0; card < this.data.cards.length; card++) {
          if (this.data.cards[card].name === test[1]) {
            testDataObject.name += `${test[1]} [Card]`;
            thatIndex = this.data.cards[card].index;
            break;
          }
        }
        if (isNaN(thatIndex)) {
          for (let relic = 0; relic < this.data.relics.length; relic++) {
            if (this.data.relics[relic].name === test[1]) {
              testDataObject.name += `${test[1]} [Relic]`;
              thatIndex = this.data.relics[relic].index;
              break;
            }
          }
        }
        if (isNaN(thatIndex)) {
          vue.testFailMessages.push(`Tests: ${test[1]} not present in data set`);
          testDataObject.name += `${test[1]} [Data not present]`;
          testDataObject.type = 'Test not run';
        }
        console.log(`Name: ${test[1]}, Index: ${thatIndex}`);

        if (!isNaN(thisIndex) && !isNaN(thatIndex)) {
          // compare synergies
          let thisFilterType;
          let thatFilterType;
          if (thisIndex < this.data.cards.length) {
            thisFilterType = this.data.cards;
          }
          else {
            thisFilterType = this.data.relics;
          }
          if (thatIndex < this.data.cards.length) {
            thatFilterType = this.data.cards;
          }
          else {
            thatFilterType = this.data.relics;
          }
          const thisObject = thisFilterType.find(item => item.index === thisIndex);
          const thisObjectIndex = thisObject.index;
          const thatObject = thatFilterType.find(item => item.index === thatIndex);
          const thatObjectIndex = thatObject.index;

          console.log(`Is ${thisObject.index} (${thisObject.name}) in ${thatObject.name} Synergies [${thatObject.synergies.toString()}]`);
          let objectKey = '';

          if (test[2] === 'synergy') {
            objectKey = 'synergies';
          } else if (test[2] === 'antisynergy'){
            objectKey = 'antisynergies';
          } else {
            vue.testFailMessages.push(`Tests: Missing what key (synergy, antisynergy) to test on in data object`);
            testDataObject.name += ` - Missing type of test data from datatests.json`
            testDataObject.type = 'Test not run';
          }
          if (objectKey.length > 0) {
            const thisObjectSynergyIndex = thisObject[objectKey].find(synergy => synergy === thatIndex)
            const thatObjectSynergyIndex = thatObject[objectKey].find(synergy => synergy === thisIndex)
            if (thisObjectIndex === thatObjectSynergyIndex &&
              thatObjectIndex === thisObjectSynergyIndex) {
              testDataObject.pass = true;
            }
          }
        }
        vue.testResults.push(testDataObject);
        console.groupEnd();

      });
    },


    // --------------------------
    // Prerendering Data Compiler
    // --------------------------

    prerenderdata() {
      const routes = [
        '/',
        '/tools/slaythespire/',
        '/tools/slaythespire/devlog/',
        '/tools/slaythespire/tierlist/cards/ironclad/',
        '/tools/slaythespire/tierlist/cards/silent/',
        '/tools/slaythespire/tierlist/cards/defect/',
        '/tools/slaythespire/tierlist/cards/watcher/',
        '/tools/slaythespire/tierlist/cards/colorless/',
        '/tools/slaythespire/tierlist/relics/ironclad/',
        '/tools/slaythespire/tierlist/relics/silent/',
        '/tools/slaythespire/tierlist/relics/defect/',
        '/tools/slaythespire/tierlist/relics/watcher/',
      ];
      // get all cards
      this.data.cards.forEach((item) => {
        /* tslint:disable-next-line:max-line-length */
        routes.push(`/tools/slaythespire/cards/${item.name.replace(/\s/g, '').replace(/\'/g, '').replace(/\-/g, '').toLowerCase()}/`);
      });

      this.data.relics.forEach((item) => {
        /* tslint:disable-next-line:max-line-length */
        routes.push(`/tools/slaythespire/relics/${item.name.replace(/\s/g, '').replace(/\'/g, '').replace(/\-/g, '').toLowerCase()}/`);
      });
      // get all relics
      // this.data.relics.forEach(item => {
      //   routes.push(`/tools/slaythespire/relics/${item.name.replace(/\s/g, '').replace(/\'/g, '').replace(/\-/g, '').toLowerCase()}`)
      // })

      // Sort urls        // consider any external urls
      this.prerenderOutput = JSON.stringify(routes.sort());
      // Compare current compile with live route render list
      this.prerenderIdentical = this.prerenderRoutesIdentical(this.prerenderOutput, JSON.stringify(this.prerenderCurrentRoutes));

    },

    // Compare arrays
    prerenderRoutesIdentical(a, b) {
      if (a === b) {
        return true;
      }
      if (a == null || b == null) {
        return false;
      }
      if (a.length !== b.length) {
        return false;
      }

      // If you don't care about the order of the elements inside
      // the array, you should sort both arrays here.

      for (let i = 0; i < a.length; ++i) {
        if (a[i] !== b[i]) {
          return false;
        }
      }
      return true;
    },
  },
  computed: {
    isUnlocked() {
      if (this.a37891hd821nd9q8eej9 !== this.password) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.compiler {
  background: #10212b;
  min-height: 100vh;
  margin: 0;
  padding: 120px 60px;
  color: #fff6e1;
  font-family: 'Kreon', serif;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.wrapper {
  width: 94%;
  max-width: 1000px;
}
.flex {
  display: flex;
  justify-content: space-between;
  margin: 30px 0;
  > div {
    width: 48%;
  }
}
.textinput {
  width: 100%;
  height: 400px;
  padding: 20px;
  background: #1a4055;
  border-radius: 10px;
  border: 4px solid #e0c10f;
}

.button {
  background: #185db6;
  text-align: center;
  padding: 14px;
  width: 300px;
  margin: auto;
  border-radius: 10px;
  &:hover {
    cursor: pointer;
    transform: scale(1.1);
  }
}
.errors {
  list-style: none;
  width: 80%;
  padding: 0;
  // max-height: 200px;
  overflow-x: scroll;
  > li {
    margin: 10px 0;
    padding: 0;
    text-align: left;
  }
}
.tests {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  text-align: left;
  div {
    display: flex;
  }
  p {
    padding: 10px 16px;
    text-shadow: 1px 1px 0 rgba(#000, 0.5);
    background: #185db6;
  }
  p.fail {
    background: #D63F42;
    margin-right: 20px; 
  }
  p.fail-main {
    background: #992c2e;
  }

  p.pass {
    background: #58D970;
    margin-right: 20px; 
  } 
  p.pass-main {
    background: #3d964d;
  }
  p.notrun {
    background: #666666;
    margin-right: 20px; 
  } 
  p.notrun-main {
    background: #414141;
  }
}
</style>
